/* Tiny shared formatting helpers used by a couple of step screens. */
export const money = (n: number): string => '$' + n.toLocaleString('en-US');
export const art = (w: string): string => (/^[aeiou]/i.test(w || '') ? 'an' : 'a');
